/* eslint-disable import/prefer-default-export */

import { getItemsForEstimate } from './getItemsForEstimate';

export const getDiscontinuedItemsCount = (entities, estimateId) =>
  getItemsForEstimate(entities, estimateId).reduce(
    (acc, item) => (item.itemProduct && item.itemProduct.productStatus === 'Discontinued' ? acc + 1 : acc),
    0,
  );
